module.exports = __webpack_public_path__ + "static/media/paredes_vivas_3.47628bb2.jpg";